import React from "react";
import { Reveal, Overline } from "./Motion";
import { OFFERS } from "@/data/cafe";
import { useDialogs } from "./DialogProvider";
import { ArrowUpRight } from "lucide-react";

export default function Offers() {
  const { open } = useDialogs();
  return (
    <section id="offers" className="bg-[#F5F2EB] py-24 md:py-32" data-testid="offers-section">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <Overline>Offers</Overline>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1A1514] mt-4 font-medium">
            Rewards worth <span className="italic text-[#1C7C54]">savouring</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-14">
          {OFFERS.map((o, i) => {
            const isCatering = o.title === "Corporate Catering";
            return (
              <Reveal key={o.title} delay={(i % 3) * 0.08}>
                <div className={`rounded-sm p-8 h-full border transition-colors duration-300 group ${
                  isCatering ? "bg-[#1C7C54] border-[#1C7C54] text-[#F5F2EB]" : "bg-[#F5F2EB] border-[#1A1514]/12 hover:border-[#1C7C54]"
                }`} data-testid={`offer-${i}`}>
                  <div className="flex items-center justify-between">
                    <span className={`overline ${isCatering ? "text-[#F5F2EB]/80" : "text-[#1C7C54]"}`}>{o.tag}</span>
                    {isCatering && <ArrowUpRight className="h-5 w-5" />}
                  </div>
                  <h3 className={`font-display text-3xl mt-6 ${isCatering ? "text-[#F5F2EB]" : "text-[#1A1514]"}`}>{o.title}</h3>
                  <p className={`font-body mt-3 leading-relaxed ${isCatering ? "text-[#F5F2EB]/85" : "text-[#1A1514]/60"}`}>{o.desc}</p>
                  {isCatering && (
                    <button onClick={() => open("catering")} data-testid="offer-catering-btn"
                      className="mt-6 rounded-sm bg-[#1A1514] text-[#F5F2EB] px-6 py-3 font-accent text-xs uppercase tracking-[0.15em] hover:bg-black transition-colors">
                      Request Catering
                    </button>
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
